import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSort } from '@angular/material/sort';
import { SiteAuditService } from '@app/features/site-audit/site-audit.service';
import { FortigatesService } from '@app/features/fortigates/shared/fortigates.service';

@Component({
    selector: 'app-site-audit',
    templateUrl: './site-audit.component.html',
    styleUrls: ['./site-audit.component.scss'],
    standalone: false
})
export class SiteAuditComponent implements OnInit {

  @ViewChild('firmwareAuditTable') firmwareAuditTable: MatTable<any>;
  @ViewChild('modelAuditTable') modelAuditTable: MatTable<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  firmware = [];
  firmwareDisplayedColumns = ['device', 'recommendation'];
  firmwareDataSource = new MatTableDataSource<any>(this.firmware);
  model = [];
  modelDisplayedColumns = ['device', 'recommendation'];
  modelDataSource = new MatTableDataSource<any>(this.model);
  storeNumber: string = '';
  wan1Interface: any;
  wan1InterfaceLoading: boolean = false;
  firmwareAndModelAuditLoading: boolean = false;

  constructor(
    private siteAuditService: SiteAuditService, 
    private fortigatesService: FortigatesService,
    private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.queryParams.subscribe(params => {
      if ('storeNumber' in params) {
        this.storeNumber = params['storeNumber'];
        this.getSiteAudit();
      }
    });
  }

  ngOnInit() {
  }

  async getSiteAudit() {
    await this.getFirmwareAndModelAudits();
    await this.getWan1InterfaceAudit();
  }

  getFirmwareAndModelAudits() {
    this.firmwareAndModelAuditLoading = true;
    return this.siteAuditService.getSiteAudit(this.storeNumber).then((observable) => {
      observable.toPromise().then((response) => {
        let audits = response["message"];
        this.modelDataSource.data = audits["model"];
        this.firmwareDataSource.data = audits["firmware"];
        this.modelAuditTable.renderRows();
        this.firmwareAuditTable.renderRows();
        this.firmwareAndModelAuditLoading = false;
      });
    });
  }

  getWan1InterfaceAudit() {
    this.wan1InterfaceLoading = true;
    return this.fortigatesService.getWan1Interface(this.storeNumber).then((observable) => {
      observable.toPromise().then((response) => {
        // The endpoint returns one entry per FortiGate at the store; a store only
        // ever has one primary circuit, so show the first.
        const wan1Interfaces = response["message"];
        this.wan1Interface = Array.isArray(wan1Interfaces) && wan1Interfaces.length > 0
          ? wan1Interfaces[0]["wan1-interface"]
          : null;
        this.wan1InterfaceLoading = false;
      })
    })
  }

}
